import React, { memo, useEffect, useMemo, useState } from "react"
import QuickWidgetDialog from "../../../quickWidgetDialog/quickWidgetDialog"
import { useSelector } from "react-redux"
import { Box, Table, TableBody, Typography, CircularProgress, } from "@mui/material"
import { QuickWidgetTypes } from "../../../../reducer/user.reducer"
import { Order, OrderStatus } from "../../../../proto/generated/order"
import OrderRow from '../../../ordersWidget/OrderRow'
import { selectOrdersHistory } from '../../../../selectors/orders'
import OrdersTableHeader from '../../../ordersWidget/OrdersTableHeader'
import { OrdersNavButtonsDetailed } from '../../../postionsWidget'
import { fetchSecuritySnapshotsBulk } from "../../../../services/apis/candles"
import websocketActions from "../../../../actions/websocket.actions"
import { subscriptionTags } from "../../../../assets/constants"
import { useDispatch } from "react-redux"

const OrdersWidget: React.FC = () => {
    const ordersData = useSelector(selectOrdersHistory)
    const dispatch = useDispatch()
    const [showContent, setShowContent] = useState(false)
    const [openOrders, setOpenOrders] = useState<Order[]>([])

    useEffect(() => {
        const timeoutId = setTimeout(() => setShowContent(true), 200)
        return () => clearTimeout(timeoutId)
    }, [])

    useEffect(() => {
        const excludedStatuses = [OrderStatus.REJECTED, OrderStatus.CANCELLED, OrderStatus.EXECUTED, OrderStatus.FAILED];
        const filtered = ordersData?.filter(order => order.status && !excludedStatuses.includes(order.status)) ?? [];
        setOpenOrders(filtered)
    }, [ordersData])

    // Loading snapshots for orders in quick orders widget
    const securities = useMemo(()=>{
        return openOrders.map((order)=> order.security)
    },[openOrders])

    useEffect(() => {
        if (!securities || !securities.length) return;
        fetchSecuritySnapshotsBulk({ securities, dispatch });
        websocketActions.setWebsocketSubscribeList(dispatch, {
            securitySnapshotSubscriptions: [
                {
                    tag: subscriptionTags.ORDERS_WIDGET_SUBSCRIPTION_TAG,
                    securities
                }
            ]
        })
    }, [securities])

    return (
        <QuickWidgetDialog widgetType={QuickWidgetTypes.ORDER} title=" Open Orders">
            {!showContent ? (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress size={20} />
                </Box>
            ) : openOrders.length === 0 ? (
                <Typography variant="body2" textAlign="center" mt={2} mb={2}>
                    No open orders.
                </Typography>
            ) : (
                <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
                    <Table size="small" stickyHeader className={'font-feature-num'}>
                        <OrdersTableHeader tabType={OrdersNavButtonsDetailed.OPEN} />
                        <TableBody>
                            {openOrders.map((order) => (
                                <OrderRow key={order.clientOrderId} order={order} hideOrderStatus={true} tabType={OrdersNavButtonsDetailed.OPEN} />
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            )}
        </QuickWidgetDialog>
    )
}

export default memo(OrdersWidget)